import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a view for filtering messages.
 * @extends JetView
 */
export default class FilterMessagesView extends JetView {
    /**
     * Configures the layout of the filter messages view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing input fields for filtering messages
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Id', // Input for Message Id
                            type: 'number',
                            label: "<span class='icon-id'></span>" + _('Mensaje Id'),
                            labelPosition: 'top',
                            placeholder: _('Mensaje Id'),
                            invalidMessage: _('Mensaje Id is required'), // Validation message
                        },
                        {
                            view: 'text',
                            name: 'GlobalId', // Input for Global Id
                            type: 'number',
                            label: "<span class='icon-id'></span>" + _('Global Id'),
                            labelPosition: 'top',
                            placeholder: _('Global Id'),
                            invalidMessage: _('Global Id is required'), // Validation message
                        },
                        {
                            view: 'text',
                            name: 'Name', // Input for Name
                            label: "<span class='icon-user'></span>" + _('Nombre'),
                            labelPosition: 'top',
                            placeholder: _('Nombre'),
                            invalidMessage: _('Nombre is required'), // Validation message
                        },
                        {
                            view: 'richselect',
                            name: 'Type', // Dropdown for Type selection
                            label: _('Tipo'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: '1', value: _('Casino') },
                                { id: '2', value: _('Live Casino') },
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'ClientIdFrom', // Input for Client Id From
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('Emisor'),
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'),
                        },
                        {
                            view: 'text',
                            name: 'ClientIdTo', // Input for Client Id To
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('Receptor'),
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'),
                        },
                        {
                            view: 'richselect',
                            name: 'Read', // Dropdown for Read status
                            label: _('Leido?'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: '1', value: _('Si') },
                                { id: '0', value: _('No') },
                            ],
                        },
                        {
                            view: 'richselect',
                            name: 'IsActivate', // Dropdown for Activation status
                            label: "<span class='icon-state'></span>" + _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                    ],
                },
            ],
        };

        // Second left section with additional filters
        const left2 = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'IsVerified', // Dropdown for Verified status
                            label: "<span class='icon-verified_user'></span>" + _('Verificado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                        {
                            view: 'text',
                            name: 'Abbreviated', // Input for Abbreviated field
                            label: _('Abreviado'),
                            labelPosition: 'top',
                            placeholder: _('Abreviado'),
                            invalidMessage: _('Abreviado is required'), // Validation message
                        },
                        { id: 'grav2', gravity: 1 }, // Gravity for layout
                    ],
                },
            ],
        };

        // Upper section layout
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 230 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left], // Includes the first left section
                },
            ],
        };

        // Second upper section layout
        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 130 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Includes the second left section
                },
            ],
        };

        // Accordion section for advanced filters
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Header for advanced filters
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Includes the second upper section
                            },
                        },
                    ],
                },
            ],
        };

        // Buttons section for actions
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Añadir Mensaje'), // Button to add message
                            type: 'form',
                            width: screen == 'small' ? 0 : 150,
                            hidden: !devConfig.getPermAction(
                                'messageListAdd',
                                'Add', // Permission check for adding messages
                            ),
                            css: 'prm-messageListAdd',
                            click: () => {
                                this.app.callEvent('addMessage:button', [[]]); // Event to add message
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Limpiar'), // Button to clear filters
                            width: screen == 'small' ? 0 : 100,
                            click: () => {
                                this.getRoot().clear(); // Clear the form
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Consultar'), // Button to consult messages
                            type: 'form',
                            width: screen == 'small' ? 0 : 150,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get filter values
                                this.app.callEvent('messages:filter', [
                                    filterdata, // Event to filter messages
                                ]);
                                $$('b1').collapse(); // Collapse the filter section
                                $$('a5').scrollTo(100, 0); // Scroll to a specific position
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion section for basic filters
        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for basic filters
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [
                                    upper_section, // Includes the upper section
                                    buttons, // Includes the buttons section
                                ],
                            },
                        },
                    ],
                },
            ],
        };

        // Return the main configuration for the form
        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section1], // Main content of the form
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid object passed during initialization.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide element for small screens
                $$('grav2').hide(); // Hide another element for small screens
            }
        });
    }
}

// FILE DOCUMENTED
